import React, { memo } from 'react';
import {useSelector} from 'react-redux';
import { isNormalZhEnCss} from '../../utils';
import styles from './styles.module.scss';

const Index = memo(() => {
  const {lang, home: {website}} = useSelector(({localesReducer}) => localesReducer.i18n);
  // 判断是：桌面/移动端
  const desktopMobile = () => {
    return (<p className='desc'>{website}</p>);
  };

  return (
      <div 
        className={styles.normal} 
      >
        {desktopMobile()}
      </div>
  );
});
export default Index;
